// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/**
* STORYBOOK
* If you add any variable, remember to map it into the proper Story
*/
/**
* Color palette - Facile.it
* https://www.figma.com/design/pyJeLFNc3tpFt5NkWpbt8n/Core-Foundation-%5B1.1%5D?node-id=3-4219&t=DjgtSeE8NgGaxpFm-1
*/
/* Primary */
/* Action */
/* Alert */
/* Success */
/* Help */
/* Error */
/* Chick */
/* Text */
/* Grey */
/* Neutral/warm */
/* Neutral/cold */
/* Opacity/Grey */
/* Opacity/White */
/* Opacity/Colors */
/**
* Color map - Facile.it
*/
/**
* @deprecated use Color - Facile.it palette
*/
/**
* Removes a specific item from a list.
*
* @param {list} \$list List. @param {integer} \$index Index.
* @return {list} Updated list.
*/
/**
* Gets a value from a map.
*
* @param {map} \$map Map.
* @return {string} Value.
*/
.shark ul.list {
  list-style: none;
}
.shark ul.list li {
  margin: 0.2rem 0;
  line-height: 1.2;
}
.shark ul.list li.disable {
  opacity: 0.5;
}
.shark ul.list li.disable::before {
  color: #505050;
}
.shark ul.list.list-style-circle li {
  margin: 0.5rem 0;
  padding-left: 1rem;
}
.shark ul.list.list-style-circle li::before {
  color: var(--COLOR-PRIMARY-300);
  content: "●";
  margin-right: 0.4rem;
  margin-left: -1rem;
}
.shark ul.list.list-color-black li::before {
  color: #000;
}
.shark ul.list.list-color-strong-blue li::before {
  color: #1576b3;
}
.shark ol.list {
  padding-left: 1.5rem;
}
.shark .list {
  margin: 0;
  padding: 0;
}
.shark .list.margin {
  margin: 1rem 0;
}
.shark .list.font-size-xxxl {
  font-size: 2.6rem;
}
.shark .list.font-size-xxl {
  font-size: 2.3rem;
}
.shark .list.font-size-xl {
  font-size: 1.8rem;
}
.shark .list.font-size-lg {
  font-size: 1.4rem;
}
.shark .list.font-size-md {
  font-size: 1.2rem;
}
.shark .list.font-size-std-plus {
  font-size: 1.1rem;
}
.shark .list.font-size-base {
  font-size: 1em;
}
.shark .list.font-size-std {
  font-size: 0.9em;
}
.shark .list.font-size-std-tablet {
  font-size: 0.9em;
}
.shark .list.font-size-std-mobile {
  font-size: 0.8em;
}
.shark .list.font-size-sm {
  font-size: 0.7rem;
}
.shark .list.font-size-xs {
  font-size: 0.5rem;
}
@media (min-width: 769px) {
  .shark .list.column-count-2 {
    -moz-column-count: 2;
         column-count: 2;
  }
}
@media (min-width: 769px) {
  .shark .list.column-count-3 {
    -moz-column-count: 3;
         column-count: 3;
  }
}
.shark .list.line-height-double li {
  line-height: 1.64;
}

/*# sourceMappingURL=data:application/json;base64,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 */`, "",{"version":3,"sources":["webpack://./node_modules/@facile-it/shark-morph/components/List/list.css"],"names":[],"mappings":"AAAA,gBAAgB;AAChB;;;CAGC;AACD;;;CAGC;AACD,YAAY;AACZ,WAAW;AACX,UAAU;AACV,YAAY;AACZ,SAAS;AACT,UAAU;AACV,UAAU;AACV,SAAS;AACT,SAAS;AACT,iBAAiB;AACjB,iBAAiB;AACjB,iBAAiB;AACjB,kBAAkB;AAClB,mBAAmB;AACnB;;CAEC;AACD;;CAEC;AACD;;;;;CAKC;AACD;;;;;CAKC;AACD;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,YAAY;AACd;AACA;EACE,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,+BAA+B;EAC/B,YAAY;EACZ,oBAAoB;EACpB,kBAAkB;AACpB;AACA;EACE,WAAW;AACb;AACA;EACE,cAAc;AAChB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,SAAS;EACT,UAAU;AACZ;AACA;EACE,cAAc;AAChB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,cAAc;AAChB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE;IACE,oBAAe;SAAf,eAAe;EACjB;AACF;AACA;EACE;IACE,oBAAe;SAAf,eAAe;EACjB;AACF;AACA;EACE,iBAAiB;AACnB;;AAIA,gnJAAgnJ","sourcesContent":["@charset \"UTF-8\";\n/**\n* STORYBOOK\n* If you add any variable, remember to map it into the proper Story\n*/\n/**\n* Color palette - Facile.it\n* https://www.figma.com/design/pyJeLFNc3tpFt5NkWpbt8n/Core-Foundation-%5B1.1%5D?node-id=3-4219&t=DjgtSeE8NgGaxpFm-1\n*/\n/* Primary */\n/* Action */\n/* Alert */\n/* Success */\n/* Help */\n/* Error */\n/* Chick */\n/* Text */\n/* Grey */\n/* Neutral/warm */\n/* Neutral/cold */\n/* Opacity/Grey */\n/* Opacity/White */\n/* Opacity/Colors */\n/**\n* Color map - Facile.it\n*/\n/**\n* @deprecated use Color - Facile.it palette\n*/\n/**\n* Removes a specific item from a list.\n*\n* @param {list} $list List. @param {integer} $index Index.\n* @return {list} Updated list.\n*/\n/**\n* Gets a value from a map.\n*\n* @param {map} $map Map.\n* @return {string} Value.\n*/\n.shark ul.list {\n  list-style: none;\n}\n.shark ul.list li {\n  margin: 0.2rem 0;\n  line-height: 1.2;\n}\n.shark ul.list li.disable {\n  opacity: 0.5;\n}\n.shark ul.list li.disable::before {\n  color: #505050;\n}\n.shark ul.list.list-style-circle li {\n  margin: 0.5rem 0;\n  padding-left: 1rem;\n}\n.shark ul.list.list-style-circle li::before {\n  color: var(--COLOR-PRIMARY-300);\n  content: \"●\";\n  margin-right: 0.4rem;\n  margin-left: -1rem;\n}\n.shark ul.list.list-color-black li::before {\n  color: #000;\n}\n.shark ul.list.list-color-strong-blue li::before {\n  color: #1576b3;\n}\n.shark ol.list {\n  padding-left: 1.5rem;\n}\n.shark .list {\n  margin: 0;\n  padding: 0;\n}\n.shark .list.margin {\n  margin: 1rem 0;\n}\n.shark .list.font-size-xxxl {\n  font-size: 2.6rem;\n}\n.shark .list.font-size-xxl {\n  font-size: 2.3rem;\n}\n.shark .list.font-size-xl {\n  font-size: 1.8rem;\n}\n.shark .list.font-size-lg {\n  font-size: 1.4rem;\n}\n.shark .list.font-size-md {\n  font-size: 1.2rem;\n}\n.shark .list.font-size-std-plus {\n  font-size: 1.1rem;\n}\n.shark .list.font-size-base {\n  font-size: 1em;\n}\n.shark .list.font-size-std {\n  font-size: 0.9em;\n}\n.shark .list.font-size-std-tablet {\n  font-size: 0.9em;\n}\n.shark .list.font-size-std-mobile {\n  font-size: 0.8em;\n}\n.shark .list.font-size-sm {\n  font-size: 0.7rem;\n}\n.shark .list.font-size-xs {\n  font-size: 0.5rem;\n}\n@media (min-width: 769px) {\n  .shark .list.column-count-2 {\n    column-count: 2;\n  }\n}\n@media (min-width: 769px) {\n  .shark .list.column-count-3 {\n    column-count: 3;\n  }\n}\n.shark .list.line-height-double li {\n  line-height: 1.64;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
